import React, { useContext, useEffect } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import './Projects.css';

const Projects = () => {
  const { language } = useContext(LanguageContext);
    // تغيير اتجاه النصوص بناءً على اللغة
    useEffect(() => {
      if (language === 'ar') {
        document.body.classList.add('rtl');
        document.body.classList.remove('ltr');
      } else {
        document.body.classList.add('ltr');
        document.body.classList.remove('rtl');
      }
    }, [language]);

  const content = {
    ar: {
      title: 'مشاريع المنظمة',
      columns: ['اسم المشروع', 'الموقع', 'عدد المستفيدين', 'السنة'],
      projects: [
        { name: 'كفالة الأيتام', location: 'ولاية الخرطوم وبعض الولايات', beneficiaries: '1750 يتيم', year: '2014 - 2023' },
        { name: 'محاضرات دعوية', location: 'ولاية الخرطوم وبعض الولايات', beneficiaries: '4781 فرد', year: '2020' },
        { name: 'إغاثة المتضررين', location: 'ولاية الخرطوم وبعض الولايات', beneficiaries: '1500 فرد', year: '2016 - 2022' },
        { name: 'كفالة الأسر الفقيرة', location: 'ولاية الخرطوم وبعض الولايات', beneficiaries: '1200 أسرة', year: '2018 - 2023' },
        { name: 'إعادة تأهيل المنازل المتضررة', location: 'ولاية النيل الأبيض', beneficiaries: '250 منزل', year: '2017 - 2022' },
        { name: 'حملات النظافة والتشجير', location: 'ولاية الجزيرة', beneficiaries: '3000 مستفيد', year: '2015 - 2020' },
        { name: 'مشروع توزيع ملابس', location: 'ولاية كسلا', beneficiaries: '450 فرد', year: '2019' },
        { name: 'مساعدات غذائية', location: 'ولاية شمال كردفان', beneficiaries: '200 أسرة', year: '2018' },
        { name: 'ترميم المدارس', location: 'ولاية الخرطوم', beneficiaries: '15 مدرسة', year: '2021' },
        { name: 'إنشاء آبار مياه', location: 'ولاية دارفور', beneficiaries: '3000 مستفيد', year: '2015 - 2023' },
        { name: 'توزيع مستلزمات دراسية', location: 'ولاية البحر الأحمر', beneficiaries: '700 طالب', year: '2017' },
        { name: 'حملات توعية صحية', location: 'ولاية الخرطوم', beneficiaries: '5000 مستفيد', year: '2020' },
        { name: 'مشاريع زراعية صغيرة', location: 'ولاية الجزيرة', beneficiaries: '250 مزارع', year: '2018 - 2021' },
        { name: 'حملات مكافحة التصحر', location: 'ولاية الشمالية', beneficiaries: '1500 مستفيد', year: '2019 - 2022' },
        { name: 'مشاريع تمكين النساء', location: 'ولاية الخرطوم وبعض الولايات', beneficiaries: '600 امرأة', year: '2016 - 2023' },
        { name: 'دعم المستشفيات', location: 'ولاية الخرطوم', beneficiaries: '10 مستشفيات', year: '2020 - 2022' },
        { name: 'توزيع بطانيات شتوية', location: 'ولاية كسلا', beneficiaries: '800 فرد', year: '2021' },
        { name: 'دعم العائلات النازحة', location: 'ولاية دارفور', beneficiaries: '150 أسرة', year: '2018' },
        { name: 'دورات تدريبية', location: 'ولاية النيل الأزرق', beneficiaries: '400 شخص', year: '2020' },
        { name: 'مشروع تشغيل الشباب', location: 'ولاية الخرطوم', beneficiaries: '200 شاب', year: '2019 - 2022' },
        { name: 'حملات تنظيف الشواطئ', location: 'ولاية البحر الأحمر', beneficiaries: '5000 مستفيد', year: '2017 - 2020' },
        { name: 'بناء مراكز ثقافية', location: 'ولاية القضارف', beneficiaries: '2000 مستفيد', year: '2016 - 2019' },
        { name: 'حملات فحص السكري', location: 'ولاية الخرطوم', beneficiaries: '3500 شخص', year: '2018' },
        { name: 'توزيع وجبات جاهزة', location: 'ولاية الخرطوم وبعض الولايات', beneficiaries: '500 أسرة', year: '2020' },
        { name: 'دعم أطفال المدارس', location: 'ولاية الخرطوم', beneficiaries: '1500 طالب', year: '2018 - 2022' },
        { name: 'مشروع كهرباء القرى', location: 'ولاية شمال كردفان', beneficiaries: '10 قرى', year: '2019 - 2023' },
        { name: 'مشاريع التدريب المهني', location: 'ولاية الخرطوم', beneficiaries: '250 شاب وشابة', year: '2016 - 2020' },
        { name: 'مشروع الطاقة المتجددة', location: 'ولاية الشمالية', beneficiaries: '200 منزل', year: '2018 - 2023' },
        { name: 'حملات التطعيم', location: 'ولاية كسلا', beneficiaries: '4000 طفل', year: '2019 - 2021' },
      ],
      executedProjectsTitle: 'المشاريع والأنشطة المنفذة: نموذج من التوثيق لبعض المشاريع',
      gallery: [
        { src: '/images/project1.jpg', alt: 'نشاط 1' },
        { src: '/images/project2.jpg', alt: 'نشاط 2' },
        { src: '/images/project3.jpg', alt: 'نشاط 3' },
        { src: '/images/project4.jpg', alt: 'نشاط 4' },
        { src: '/images/project5.jpg', alt: 'نشاط 5' },
        { src: '/images/project6.jpg', alt: 'نشاط 6' },
        { src: '/images/project7.jpg', alt: 'نشاط 7' },
        { src: '/images/project8.jpg', alt: 'نشاط 8' },
        { src: '/images/project9.jpg', alt: 'نشاط 9' },
        { src: '/images/project10.jpg', alt: 'نشاط 10' },
        { src: '/images/project11.jpg', alt: 'نشاط 11' },
        { src: '/images/project12.jpg', alt: 'نشاط 12' },
        { src: '/images/project13.jpg', alt: 'نشاط 13' },
        { src: '/images/project14.jpg', alt: 'نشاط 14' },
        { src: '/images/project15.jpg', alt: 'نشاط 15' },
        { src: '/images/project16.jpg', alt: 'نشاط 16' },
      ],
    },
    en: {
      title: 'Organization Projects',
      columns: ['Project Name', 'Location', 'Beneficiaries', 'Year'],
      projects: [
        { name: 'Orphan Sponsorship', location: 'Khartoum State and others', beneficiaries: '1750 orphans', year: '2014 - 2023' },
        { name: 'Religious Lectures', location: 'Khartoum State and others', beneficiaries: '4781 people', year: '2020' },
        { name: 'Disaster Relief', location: 'Khartoum State and others', beneficiaries: '1500 people', year: '2016 - 2022' },
        { name: 'Poor Family Sponsorship', location: 'Khartoum State and others', beneficiaries: '1200 families', year: '2018 - 2023' },
        { name: 'Rehabilitation of Damaged Houses', location: 'White Nile State', beneficiaries: '250 houses', year: '2017 - 2022' },
        { name: 'Cleaning and Tree-Planting Campaigns', location: 'Gezira State', beneficiaries: '3000 beneficiaries', year: '2015 - 2020' },
        { name: 'Clothing Distribution Project', location: 'Kassala State', beneficiaries: '450 people', year: '2019' },
        { name: 'Food Aid', location: 'North Kordofan State', beneficiaries: '200 families', year: '2018' },
        { name: 'School Renovation', location: 'Khartoum State', beneficiaries: '15 schools', year: '2021' },
        { name: 'Water Wells Construction', location: 'Darfur State', beneficiaries: '3000 beneficiaries', year: '2015 - 2023' },
        { name: 'School Supplies Distribution', location: 'Red Sea State', beneficiaries: '700 students', year: '2017' },
        { name: 'Health Awareness Campaigns', location: 'Khartoum State', beneficiaries: '5000 beneficiaries', year: '2020' },
        { name: 'Small Agricultural Projects', location: 'Gezira State', beneficiaries: '250 farmers', year: '2018 - 2021' },
        { name: 'Desertification Control Campaigns', location: 'Northern State', beneficiaries: '1500 beneficiaries', year: '2019 - 2022' },
        { name: 'Women Empowerment Projects', location: 'Khartoum State and others', beneficiaries: '600 women', year: '2016 - 2023' },
        { name: 'Hospital Support', location: 'Khartoum State', beneficiaries: '10 hospitals', year: '2020 - 2022' },
        { name: 'Winter Blanket Distribution', location: 'Kassala State', beneficiaries: '800 people', year: '2021' },
        { name: 'Displaced Family Support', location: 'Darfur State', beneficiaries: '150 families', year: '2018' },
        { name: 'Training Courses', location: 'Blue Nile State', beneficiaries: '400 people', year: '2020' },
        { name: 'Youth Employment Project', location: 'Khartoum State', beneficiaries: '200 youth', year: '2019 - 2022' },
        { name: 'Beach Cleaning Campaigns', location: 'Red Sea State', beneficiaries: '5000 beneficiaries', year: '2017 - 2020' },
        { name: 'Cultural Center Construction', location: 'Gadaref State', beneficiaries: '2000 beneficiaries', year: '2016 - 2019' },
        { name: 'Diabetes Screening Campaigns', location: 'Khartoum State', beneficiaries: '3500 people', year: '2018' },
        { name: 'Ready Meal Distribution', location: 'Khartoum State and others', beneficiaries: '500 families', year: '2020' },
        { name: 'School Children Support', location: 'Khartoum State', beneficiaries: '1500 students', year: '2018 - 2022' },
        { name: 'Village Electrification Project', location: 'North Kordofan State', beneficiaries: '10 villages', year: '2019 - 2023' },
        { name: 'Vocational Training Projects', location: 'Khartoum State', beneficiaries: '250 youth', year: '2016 - 2020' },
        { name: 'Renewable Energy Project', location: 'Northern State', beneficiaries: '200 houses', year: '2018 - 2023' },
        { name: 'Vaccination Campaigns', location: 'Kassala State', beneficiaries: '4000 children', year: '2019 - 2021' },
      ],
      executedProjectsTitle: 'Executed Projects and Activities: Documentation Examples of Some Projects',
      gallery: [
        { src: '/images/project1.jpg', alt: 'نشاط 1' },
        { src: '/images/project2.jpg', alt: 'نشاط 2' },
        { src: '/images/project3.jpg', alt: 'نشاط 3' },
        { src: '/images/project4.jpg', alt: 'نشاط 4' },
        { src: '/images/project5.jpg', alt: 'نشاط 5' },
        { src: '/images/project6.jpg', alt: 'نشاط 6' },
        { src: '/images/project7.jpg', alt: 'نشاط 7' },
        { src: '/images/project8.jpg', alt: 'نشاط 8' },
        { src: '/images/project9.jpg', alt: 'نشاط 9' },
        { src: '/images/project10.jpg', alt: 'نشاط 10' },
        { src: '/images/project11.jpg', alt: 'نشاط 11' },
        { src: '/images/project12.jpg', alt: 'نشاط 12' },
        { src: '/images/project13.jpg', alt: 'نشاط 13' },
        { src: '/images/project14.jpg', alt: 'نشاط 14' },
        { src: '/images/project15.jpg', alt: 'نشاط 15' },
        { src: '/images/project16.jpg', alt: 'نشاط 16' },
      ],
    },
  };

  const langContent = content[language];

  return (
    <div className="projects">
      <h2>{langContent.title}</h2>
      <table>
        <thead>
          <tr>
            {langContent.columns.map((column, index) => (
              <th key={index}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {langContent.projects.map((project, index) => (
            <tr key={index}>
              <td>{project.name}</td>
              <td>{project.location}</td>
              <td>{project.beneficiaries}</td>
              <td>{project.year}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h3>{langContent.executedProjectsTitle}</h3>
      <div className="projects-gallery">
        {langContent.gallery.map((image, index) => (
          <img key={index} src={image.src} alt={image.alt} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
